import { useFormikContext } from 'formik';
import { useRfiForm } from './RfiFormProvider';
import {
  AssignedTo,
  CustomIdentifier,
  Question,
  DueDate,
  LocationDetails,
  Location,
  ScrollErrorToView,
  SuggestedAnswer,
  Title,
  RfiType,
  Status,
  ExternalId,
  Watchers,
} from './fields';
import {
  CostImpactInCreateForm as CostImpact,
  ScheduleImpactInCreateForm as ScheduleImpact,
  PriorityInCreateForm as Priority,
  DisciplineInCreateForm as Discipline,
  CategoryInCreateForm as Category,
} from '../components/Form';
import { ISSUE_ATTRIBUTE_NAMES } from '../constants/issue-attribute-names';
import IssuePreviewNoWorkflowConfiguration from '../components/IssuePreviewNoWorkflowConfiguration';
import { RfiStatus } from '../sdk';

const RfiForm = () => {
  const formik = useFormikContext();
  const isStatusDraft = formik.values.status === RfiStatus.Draft;
  const displayRfiType = !isStatusDraft;

  const {
    isRfiCustomIdentifierVisible,
    showNoWorkflowConfiguration,
    setSelectedTransition,
    prevSelectedTransition,
    refs,
  } = useRfiForm();

  const noWorkflow = showNoWorkflowConfiguration && (
    <IssuePreviewNoWorkflowConfiguration
      closePopup={() => {
        formik.setFieldValue(ISSUE_ATTRIBUTE_NAMES.STATUS, prevSelectedTransition.serverStatus);
        setSelectedTransition(prevSelectedTransition);
      }}
    />
  );

  return (
    <form onSubmit={formik.handleSubmit}>
      {noWorkflow}
      <ScrollErrorToView fieldRefs={refs} />
      <Status />
      {isRfiCustomIdentifierVisible && <CustomIdentifier />}
      <Title />
      {displayRfiType && <RfiType />}
      <AssignedTo />
      <DueDate />
      <Question />
      <SuggestedAnswer />
      <Location />
      <LocationDetails />
      <CostImpact />
      <ScheduleImpact />
      <Priority />
      <Discipline />
      <Category />
      <ExternalId />
      <Watchers />
    </form>
  );
};
export default RfiForm;
